<template>
  <div class="body-container border-container">
    <p class="notification-title">
      <!-- <span>
        <i class="fa fa-bell pr-2" aria-hidden="true"></i>
      </span> -->
      <span v-translate:notification_list_header_title="lang">Notifications</span>
    </p>
    <div class="notification-container select-scroll">
      <div class="notification-list">
        <div class="row d-block" v-infinite-scroll="loadMoreNotifications" :infinite-scroll-disabled="pageIndex >= maxPages" infinite-scroll-distance="10">
          <div class="bg_blue " :style="styleObj(notify)" v-for="notify in notifications" :key="notify.notificationId">
            <div class="col-md-12 only_padding" @click="onNotificationClick(notify)" style="cursor: pointer;">
              <div class="row">
                <div class="col-md-10 notif-msg p-0">
                  <b v-translate:dynamic_string="{ key: `${notify.notificationMlKey}`, val: lang, html: notify.notificationText }">{{ notify.notificationText }}</b>
                </div>
                <div class="col-md-2 text-right pr-0">{{ notify.localnotificationTriggeredTime | customDateFilter }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center mt-20 mb-20" v-if="notifications && notifications.length > 0">
          <button class="btn btn-clear primary-border primary-text" id="clear_all_notify" data-toggle="modal" data-target="#clearAllConfirm" v-translate:button_title_clear_all_notification="lang">Clear All</button>
        </div>
        <div class="text-center mt-43 mb-43" v-else>
          <h4 v-translate:notification_not_available="lang">No notifications available.</h4>
        </div>
      </div>
    </div>

    <!-- activity-no-available -->
    <div class="confirmEmailModel">
      <div class="modal fade" id="leaveStudyModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <div class="verification text-center">
                <div v-for="notify in popUpActivitymessageList" :key="notify.notificationId">
                  <h6 :class="notify.delay ? '' : 'email-id box-padding'" v-if="notify.notificationText" v-translate:dynamic_string="{ key: `${notify.notificationMlKey}`, val: lang, html: notify.notificationText }">{{ notify.notificationText }}</h6>
                </div>
              </div>
              <div class="row leave_study_btn_grp">
                <div class="col-md-12">
                  <button class="btn leavestudy" v-translate:rsb_consent_review_cancel="lang" data-dismiss="modal" aria-label="Close">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- clear-All-notification-confirm -->
    <div class="confirmEmailModel">
      <div class="modal fade" id="clearAllConfirm" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog " role="document">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" onclick="$('#clearAllConfirm').modal('hide');" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <div class="verification text-center mt-15 pt-17 p-2">
                <label class="email-id" v-translate:clear_notification_confirmation_message="lang">Are you sure you want to clear all notifications? All notifications will be permanently deleted.</label>
              </div>
              <div class="row leave_study_btn_grp">
                <div class="col-6 col-md-6">
                  <button type="button" onclick="$('#clearAllConfirm').modal('hide');" aria-label="Close" class="btn leavestudy" v-translate:CANCEL_BUTTON_TITLE="lang">Cancel</button>
                </div>
                <div class="col-6 col-md-6">
                  <button class="btn leave_study_cntue" data-toggle="modal" data-target="#YesleaveStudyModal" data-dismiss="modal" @click="clearAllNotification" v-translate:YES_TEXT="lang">Yes</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { Bitrise, Graph, Widget, ParticipantPortal } from "@/components/services/participant-service";
import { ACTION_NAME } from "@/constants/dynamicSchedulingConstants";

export default {
  name: "notification-list",
  props: ["clickableTasks"],
  data() {
    return {
      notifyCount: 0,
      graph: new Graph(),
      bitrise: new Bitrise(),
      globalElement: null,
      widget: new Widget(),
      portal: new ParticipantPortal(),
      popUpActivitymessageList: [],
      perticularNotificationsList: [],
      notifications: [],
      scheduleDay: null,
      pageIndex: 1,
      maxPages: null,
      initialLoaded: [],
      checkForStudyStart: null
    };
  },
  computed: {
    ...mapGetters(["participant", "token", "participantStudyStartStatus", "getWebSocketServiceData"]),
    lang() {
      let selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    study() {
      return this.$store.getters.getParticipantsPortalStudyData;
    }
  },
  async mounted() {
    if (this.study && !this.study.isManualStudyStart) {
      await this.getNotifications();
    }
    this.addJustInTimeNotificationMsgListener();
    this.$root.$on("trigger_Notification", notifyObj => {
      this.pageIndex = notifyObj.page;
      this.getNotifications(notifyObj.status);
    });
    this.$root.$on("activityCompleted", taskInstanceId => {
      let notifyObjArray = this.notifications.find(item => item.taskInstanceId === taskInstanceId);
      this.$root.$emit("readNotification", notifyObjArray);
    });
  },
  watch: {
    getWebSocketServiceData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val && val.messageCount) {
          this.getNotifications();
        }
      }
    },
    participantStudyStartStatus: {
      handler(newValue) {
        this.getNotifications();
      },
      deep: true
    }
  },
  methods: {
    styleObj(notify) {
      return {
        backgroundColor: "white"
      };
    },
    loadMoreNotifications(store = false) {
      if (this.maxPages <= this.pageIndex) {
        return;
      }
      this.pageIndex++;
      let postData = { offset: moment().format("Z"), pageIndex: this.pageIndex, scheduleDay: this.graph.getUserDay(), webActive: true, web: false, readAllFlag: false };
      return this.$api.postParticipantNotification(this.participant.pid, { isWeb: true }, this.participant.myStudyVersionId, this.graph.getUserDay(), postData).then(
        response => {
          this.maxPages = response.data.totalPages;
          this.pageIndex = response.data.currentPage;
          let notifications = response.data.participantNotificationsList ? response.data.participantNotificationsList : [];
          this.notifications = [...this.notifications, ...notifications];
          this.$emit("from-notify-data", response.data.unreadCount);
          if (store && this.notifications.length > 0) {
            this.initialLoaded[this.initialLoaded.length] = {
              pageIndex: this.pageIndex,
              data: notifications
            };
          } else {
            this.updateReadStatus(notifications, response.data.currentPage);
          }
        },
        () => {
          let message = this.widget.translate("notification_not_available", "No notifications available.");
          if (message) {
            this.$toastr.error(message);
          }
        }
      );
    },
    getNotifications(status = true) {
      if (status) {
        let checkManualStudyStart = this.study.isManualStudyStart;
        let studyStartStatus = this.participantStudyStartStatus;
        if (checkManualStudyStart) {
          if (!studyStartStatus.isPiConfirmed) {
            return;
          } else if (!studyStartStatus.isConfirmed) {
            return;
          }
        }
      }
      let postData = { offset: moment().format("Z"), pageIndex: this.pageIndex, scheduleDay: this.graph.getUserDay(), webActive: true, web: false, readAllFlag: false };
      return this.$api.postParticipantNotification(this.participant.pid, { isWeb: true }, this.participant.myStudyVersionId, this.graph.getUserDay(), postData).then(
        response => {
          if (response.data.totalSize > 0) {
            this.maxPages = response.data.totalPages;
            this.pageIndex = response.data.currentPage;
            this.notifications = response.data.participantNotificationsList ? response.data.participantNotificationsList : [];
            this.$emit("from-notify-data", response.data.unreadCount);
            this.$root.$emit("isManual_Notification", true);
            this.initialLoaded = [
              {
                pageIndex: this.pageIndex,
                data: response.data.participantNotificationsList
              }
            ];
            if (this.notifications.length < 15 && this.maxPages > this.pageIndex) {
              this.loadMoreNotifications(true);
            }
          }
        },
        () => {
          let message = this.widget.translate("notification_not_available", "No notifications available.");
          if (message) {
            this.$toastr.error(message);
          }
        }
      );
    },
    updateReadStatus(notifications, pageIndex) {
      let count = 0;
      notifications.forEach((val, i) => {
        let now = moment(moment().format("YYYY-MM-DD HH:mm:ss"));
        let notificationTime = moment(notifications[i].notificationTriggeredTime);
        notifications[i].readStatus = notifications[i].readStatus === null ? false : notifications[i].readStatus;
        if (!notificationTime.isAfter(now) && notifications[i].web == false) {
          notifications[i].web = true;
          notifications[i].webActive = true;
          count++;
        }
      });

      try {
        let pid = this.participant.pid;
        let versionId = this.participant.myStudyVersionId;
        let userDay = this.graph.getUserDay();
        let rawData = { readAllFlag: true, offset: moment().format("Z"), pageIndex: pageIndex, scheduleDay: userDay, participantDate: moment(this.participant.startDate).format("YYYY-MM-DD"), participantNotificationsList: notifications };
        this.$api.updateParticipantNotification(pid, { isWeb: true }, versionId, userDay, rawData).then(response => {
          if (response.data.message == "success") {
            this.$emit("from-notify-data", { readTotal: count });
          }
        });
      } catch (error) {
        let message = this.widget.translate(error.message, this.lang);
        this.$toastr.error(message);
      }
    },
    onClickNotification() {
      // read all messages
      if (this.notifications.length == 0) {
        return;
      }
      if (this.initialLoaded.length > 0) {
        this.initialLoaded.forEach(item => {
          this.updateReadStatus(item.data, item.pageIndex);
        });
      }
    },
    onNotificationClick(notifyObj) {
      this.$emit("notificationClicked", notifyObj);
    },

    async clearAllNotification() {
      try {
        let rawData = {
          deleteAllFlag: true,
          offset: moment().format("Z"),
          scheduleDay: this.graph.getUserDay()
        };
        await this.$api.putParticipantsClearNotifications({ isWeb: true }, this.participant.pid, rawData).then(response => {
          if (response.body.message == "success") {
            this.notifications = [];
            this.$emit("from-notify-data", response.data.unreadCount);
            // this.$toastr.success("Successfully Clear");
          }
        });
      } catch (error) {
        let message = this.mlService.i18n(error.message, this.lang);
        this.$toastr.error(message);
      }
    },
    isActivityDynamicallyAdded() {
      return this.getWebSocketServiceData && this.getWebSocketServiceData.message && this.getWebSocketServiceData.message.actionType === ACTION_NAME.ADD_AN_ACTIVITY;
    },
    addJustInTimeNotificationMsgListener() {
      try {
        if ("serviceWorker" in navigator && navigator.serviceWorker) {
          navigator.serviceWorker.addEventListener("message", event => {
            if (event && event.data && event.data.action === "justInTimeNotificationArrived") {
              this.getNotifications();
            }
          });
        }
      } catch (error) {}
    }
  }
};
</script>

<style scoped>
.notification-title {
  margin: 0;
  font-family: RobotoRegular;
  font-size: 24px;
  font-weight: bold;
  line-height: 0.92;
  letter-spacing: -0.41px;
  text-align: center;
  color: #4a4a4a;
  padding: 12px;
}
.notification-container {
  width: 100%;
  padding: 0 0;
  background-image: radial-gradient(#ffffff, rgba(255, 255, 255, 0)), linear-gradient(to bottom, #f3f3f4, #f3f3f4);
  overflow: auto;
  max-height: calc(100vh - 47px);
}
.box-padding {
  padding-top: 3rem;
}
</style>
